module.exports = __webpack_public_path__ + "img/help-icon.47e2f6a9.svg";